import React , {useState} from 'react';
import ReactDom from "react-dom";
import Carousel from 'react-bootstrap/Carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ProjectCarousel from "./ProjectCarousel";


function ProjectPage() {
AOS.init();
  return (
    <div id="ProjectPage" className="project-section">
      <h2 className="project-title title-heading"> My Projects</h2>
      <hr className="title-hr"/>

      <table id="table1">
        <tr className="project-table">
          <td className="project-table-cells">
            <a className="project-button-hover" href="https://github.com/wonnykwak/InsureIQ">
              <div className="project-hover">
                <img className="project-pictures" src={`${process.env.PUBLIC_URL}/images/insureIQ.png`} alt="InsureIQ" />
                <div className="middle">
                  <div className="hover-heading">
                    <h2 className="project-sub-heading"> InsureIQ</h2>
                    <hr className="project-hr" />
                  </div>
                  <div className="project-text">
                    <p className="project-sub-info"> 2023 5CHackathon Winner - Health & Equity Track </p>
                  </div>
                </div>
              </div>
            </a>
          </td>
          <td className="project-table-cells">
          <a className="project-button-hover" href="https://github.com/wonnykwak/BiteRight">
              <div className="project-hover">
                <img className="project-pictures" src={`${process.env.PUBLIC_URL}/images/biteright.png`} alt="BiteRight" />
                <div className="middle">
                  <div className="hover-heading">
                    <h2 className="project-sub-heading"> BiteRight    </h2>
                    <hr className="project-hr" />
                  </div>
                  <div className="project-text">
                    <p className="project-sub-info"> 2024 5CHackathon Winner - Best 5C Hack </p>
                  </div>
                </div>
              </div>
            </a>
          </td>
        </tr>
        <tr>
        <td className="project-table-cells">
        <a className="project-button-hover" href={`${process.env.PUBLIC_URL}/Kuhnpokermodeling.pdf`}>
              <div className="project-hover">
                <img className="project-pictures project-pictures-cover" src={`${process.env.PUBLIC_URL}/images/Kuhnpokermodeling.pdf.png`} alt="Kuhn Poker Modeling" />
                <div className="middle">
                  <div className="hover-heading">
                    <h2 className="project-sub-heading"> Fast and Safe Opponent Modeling in Kuhn Poker</h2>
                    <hr className="project-hr" />
                  </div>
                  
                </div>
              </div>
            </a>
        </td>
          <td className="project-table-cells">
          <a className="project-button-hover" href={`${process.env.PUBLIC_URL}/Stephen_Kwak_Math_Thesis-9.pdf`}>
            <div className="project-hover">
              <img className="project-pictures project-pictures-cover" src={`${process.env.PUBLIC_URL}/images/Stephen_Kwak_Math_Thesis-9.pdf.png`} alt="Math Thesis" />
              <div className="middle">
                <div className="hover-heading">
                  <h2 className="project-sub-heading"> Applying Neural Networks in Quant Finance</h2>
                  <hr className="project-hr" />
                </div>
                <div className="project-text">
                    <p className="project-sub-info"> Senior Math Thesis </p>
                  </div>
              </div>
            </div>
          </a>
          {/* <a className="project-button-hover" href="/stephens-website/snpresearch.html">
            <div className="project-hover">

                <img className="project-pictures" src="images/stanfordneurodiversity.jpeg" onClick="window.open(https://wonnykwak.github.io/stephens-website/snpresearch.html)"/>

              <div class="middle">
                <div className="hover-heading">
                  <h2 className="project-sub-heading"> SNP Reach Project</h2>
                  <hr className="project-hr" />
                </div>
                <div class="project-text">
                  <p className="project-sub-info"> Stanford SNP Reach: Focsuing on Neurodiversity Awareness</p>
                </div>
              </div>
            </div>
            </a> */}
          </td>
        </tr>
      </table>
    {/* <ProjectCarousel /> */}
    </div>
)
}

export default ProjectPage;
